<template>
  <div>
    <RightTitle title="更改头像"></RightTitle>
    <div class="uar_form">
      <div class="clear">
        <div class="myhead">
          <img class="myface" :src="head" width="200" height="200" />
        </div>
        <div class="myheadIntro">
          <p class="red">如果你还没有设置自己的头像，系统会显示为默认头像，你需要自己上传一张新照片来作为自己的个人头像。</p>
          <p>头像图片上传格式限制为:{{ headType }}, 大小限制：{{ headSize }}</p>
        </div>
      </div>
      <div class="ClearsH1"></div>
      <div>
        <el-button type="primary" @click="toggleShow(true)">上传头像</el-button>
        <my-upload
          ref="uploadHead"
          field="file"
          :width="300"
          :height="300"
          :url="uploadHeadUrl"
          :params="params"
          :headers="headers"
          :value.sync="show"
          :maxSize="allowHeadSize"
          img-format="jpg"
          @input="toggleShow"
          @crop-upload-success="cropUploadSuccess"
        ></my-upload>
      </div>
    </div>
  </div>
</template>

<script>
// 记载组件
import Vue from "vue";
import RightTitle from "../../../components/RightTitle";
import myUpload from "vue-image-crop-upload";
// 加载api
import { getUserInfo } from "../../../api/user";
import { getBaseConfig } from "../../../api/index";
// 加载函数
import { getToken, getUser, setUser } from "../../../utils/auth";
import { formatQuery } from "../../../utils/fn";
export default {
  name: "person_avatar",
  components: {
    RightTitle,
    "my-upload": myUpload
  },
  beforeRouteEnter(to, from, next) {
    getUserInfo().then(res => {
      next(vm => {
        vm.head = res.data.head;
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    getUserInfo().then(res => {
      this.head = res.data.head;
      next();
    });
  },
  mounted() {
    let token = getToken();
    this.headers.Authorization = token;
    // 设置图片上传地址
    this.uploadHeadUrl =
      Vue.prototype.$userApiDomain + "/user/upload_head.html";
    getBaseConfig({
      type: "upload_head_size,upload_head_type,upload_head_type_format"
    }).then(res => {
      if (res.status == 200) {
        let uploadHeadSize = res.data["upload_head_size"];
        let uploadHeadType = res.data["upload_head_type"];
        this.headSize = uploadHeadSize["remark"];
        this.allowHeadSize = uploadHeadSize["size"];
        this.headType = uploadHeadType.join("/");
        this.headTypeFormat = res.data["upload_head_type_format"];
      }
    });
  },
  data() {
    return {
      show: false,
      params: {},
      headers: {
        Authorization: ""
      },
      head: "",
      uploadHeadUrl: "",
      headSize: "",
      headType: "",
      headTypeFormat: [],
      allowHeadSize: 0
    };
  },
  methods: {
    toggleShow(show) {
      this.show = show;
    },
    cropUploadSuccess(res) {
      if (res.status == 200) {
        this.head = res.data.path;
        this.$refs.uploadHead.reset();
        this.show = false;
        let userToken = getUser();
        userToken = JSON.parse(userToken);
        userToken.head = res.data.path;
        setUser(JSON.stringify(userToken));
        this.$notify({
          title: "成功",
          message: res.message,
          type: "success"
        });
        this.$router.push({
          query: { ...formatQuery([]) }
        });
      } else {
        this.$refs.uploadHead.reset();
        this.$notify({
          title: "警告",
          message: res.message,
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scoped>
.myhead {
  width: 200px;
  height: 200px;
  border: 1px solid #e6e6e6;
  padding: 5px;
  float: left;
  border-radius: 50%;
  overflow: hidden;
}
.myhead img {
  border-radius: 50%;
}
.myheadIntro {
  width: 630px;
  height: 200px;
  float: left;
  margin-left: 10px;
  line-height: 25px;
}
</style>